import { isEmpty } from '@app/utils';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  QO_PARTNUMBER_NOT_FOUND,
  QO_ERROR_UPC_5018,
  NO_SOS_OPTIONS_FOUND
} from '../../constants';
import { getUpdatedParts, getParts } from '../../utils';

const useSISToCartModal = () => {
  const [validParts, setValidParts] = useState([]);
  const [inValidParts, setInValidParts] = useState([]);
  const [deletedId, setDeletedId] = useState([]);

  const sisImportValidAndInvalidParts = useSelector(
    state => state.checkout?.sisImportValidAndInvalidParts
  );
  const partItems = useSelector(state => state.checkout?.partItems);

  const filterParts = useCallback(() => {
    const parts =
      sisImportValidAndInvalidParts && getParts(sisImportValidAndInvalidParts);
    if (parts && partItems) {
      const updatedPartItems = getUpdatedParts(parts, partItems);
      const validPartsData = [],
        inValidPartsData = [];
      updatedPartItems.forEach(item =>
        item.itemNumber === QO_PARTNUMBER_NOT_FOUND ||
        item.itemNumber === NO_SOS_OPTIONS_FOUND ||
        item.itemNumber === QO_ERROR_UPC_5018 ||
        !isEmpty(item.itemNumber)
          ? inValidPartsData.push(item)
          : validPartsData.push(item)
      );
      setValidParts(validPartsData);
      setInValidParts(inValidPartsData);
    }
  }, [partItems, sisImportValidAndInvalidParts]);

  useEffect(() => {
    if (partItems) {
      filterParts();
    }
  }, [filterParts, partItems]);

  const deleteInvalidItem = (item, setValues) => {
    const updatedInvalidParts = inValidParts.filter(i => i.id !== item.id);
    setDeletedId(prevState => [...prevState, { id: item.id }]);
    setInValidParts(updatedInvalidParts);
    updatedInvalidParts.length === 0 &&
      setValues('inValidItems', updatedInvalidParts);
  };

  const filterFormikValues = useCallback(
    values => {
      if (values) {
        const inValidItems = values?.inValidItems?.map(invalidItem => {
          return {
            ...invalidItem,
            partNumber: values?.partNumber[invalidItem.id].trim()
          };
        });

        const inValidItemsNew =
          inValidItems?.filter(a => !validParts?.some(s => s.id === a.id)) ||
          [];

        const inValidItemsUpdated = inValidItemsNew?.filter(
          inValiditems =>
            !deletedId?.find(
              deletedItems => inValiditems.id === deletedItems.id
            )
        );
        const items = [...inValidItemsUpdated, ...validParts];
        return items?.map(item => {
          return {
            itemNumber: item.partNumber,
            quantity: item.quantity,
            assetId: item.assetId,
            id: item.id
          };
        });
      }
    },
    [deletedId, validParts]
  );
  return {
    filterFormikValues,
    getParts,
    deleteInvalidItem,
    validParts,
    inValidParts
  };
};
export default useSISToCartModal;
